import DockingPluginBase from './DockingPluginBase';
import { updateStickyDocking } from './actions/calculateDocking';
import { Editor } from 'roosterjs-editor-core';

export default class StickyDockingPlugin extends DockingPluginBase {
    private stickyBottomBorder: HTMLDivElement;
    private intersectionObserver: IntersectionObserver;
    private scrolledIntoView: boolean;

    public getName() {
        return 'StickyDocking';
    }

    public initialize(editor: Editor) {
        super.initialize(editor);

        this.scrolledIntoView = false;
        this.updateIntersectionObserver();
    }

    public dispose() {
        this.updateIntersectionObserver();
        super.dispose();
    }

    public setStickyBottomBorder(div: HTMLDivElement) {
        this.stickyBottomBorder = div;
        this.updateIntersectionObserver();
    }

    public setInitialVisiblePart(initialVisiblePart: HTMLDivElement) {
        super.setInitialVisiblePart(initialVisiblePart);
        this.updateIntersectionObserver();
    }

    protected onScrollContainerChanged = (scrollContainer: HTMLDivElement) => {
        this.updateIntersectionObserver();
    };

    private updateIntersectionObserver() {
        const scrollContainer = this.scrollAdapter.getScrollContainer();

        // TODO: Once we support compose projection window, need to make sure the observer code works well in projection window
        // We can check this.viewState.isPopout to know if this is in popout window
        if (this.stickyBottomBorder && this.editor && scrollContainer) {
            if (!this.intersectionObserver) {
                this.intersectionObserver = new IntersectionObserver(
                    (entries: IntersectionObserverEntry[]) => {
                        if (entries[0]) {
                            // The observed "sticky bottom border" is a 1px height DIV, when it is inside the view, intersectionRatio should be 1.
                            // If its value is not 1, it means this border is out of the view
                            const isOutOfView = entries[0].intersectionRatio != 1;
                            updateStickyDocking(this.viewState, isOutOfView);
                            if (isOutOfView && !this.scrolledIntoView) {
                                this.tryScrollIntoView();
                            }
                            this.scrolledIntoView = true;
                        }
                    },
                    {
                        rootMargin: '0px',
                        threshold: [1],
                        root: scrollContainer,
                    }
                );
                this.intersectionObserver.observe(this.stickyBottomBorder);
            }
        } else {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        }
    }
}
